export function inferRegionFromUrlParams(): string | null {
  const params = new URL(window.location.href).searchParams;

  const uriRegion = params.get('region');
  return uriRegion;
}
